import { TextField, Box, Button, Card, CardContent, Paper, Chip, Divider, FormControl, FormControlLabel, Grid, Typography, LinearProgress, Switch } from "@mui/material";
import { Clear, Done, ArrowDropUp } from "@mui/icons-material";
import * as moment from "moment";
import "moment/locale/tr";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import Modal from "../../components/Modal/Modal";
import { useTranslation } from "react-i18next";
import { getConfirmOrder, getCancelOrder, resetOrderResponse, downloadExcelFile } from "../../store/actions/OperatorRequestActions";
import { getUnPlannedMaintenanceListMultiple, getStatusList, getAreaList, getReasonGroup, resetStore } from "../../store/actions/breakDownTasksActions";
import { getUserInfo } from "../../store/actions/userActions";
import { setSnackMessage } from "../../store/actions/layoutActions";
import { checkUserRole } from "../../api/userApi";
import ScrollTop from "react-scrolltop-button";
import InfiniteScroll from "react-infinite-scroll-component";
import ls from "local-storage";
import FilterButton from "../../components/FilterButton/FilterButton";
import FilterDrawer from "../../components/FilterDrawer/FilterDrawer";
import DetailFilter from "../../components/DetailFilter/DetailFilter";
import { StyledGridUl, StyledListItem } from "../BreakdownList/styled";
import { isMobile } from "react-device-detect";
import { useHistory } from "react-router-dom";
import OperatorRequestCard from "../../components/OperatorRequestCard/OperatorRequestCard";

const blackTextTypography = {
    color: "#000000",
};

const ss = sessionStorage;

export default function OperatorRequest(props) {
    const plantId = localStorage.getItem("plantId");
    const dispatch = useDispatch();
    const [pageLoaded, setPageLoaded] = useState(false);
    let [selectedStatusName, setSelectedStatusName] = useState([]);
    const { t } = useTranslation("translation");
    const [userID, setUserID] = useState();
    const [currentUserCode, setCurrentUserCode] = useState();
    const [currentUserName, setCurrentUserName] = useState();
    const [canCancelAnyTask, setCanCancelAnyTask] = useState(false);
    const [rowLength, setRowLength] = useState(3);
    let history = useHistory();
    const [excelFilterState, setExcelFilterState] = useState({});

    //set current date
    const setCurrentDate = (date) => {
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var modifiedMonth = month <= 9 ? "0" + month : month;
        var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        var newStartDate = year + "-" + modifiedMonth + "-" + day;
        return newStartDate;
    };

    const [state, setState] = useState({
        areaGroupId: parseInt(ss.getItem("areaGroupId")) || null,
        checkedMe: false,
        status: ls.get("status") || [1, 2, 3, 4],
        taskID: 0,
        selectedAreaName: ss.getItem("selectedAreaName") || null,
        selectedMaintenanceOrderId: ss.getItem("selectedMaintenanceOrderId") || null,
        breakdownReasonGroup: ss.getItem("or_breakdownReasonGroup" + plantId) ? JSON.parse(ss.getItem("or_breakdownReasonGroup" + plantId)) : [],
        selectedAreaFilter: ss.getItem("or_areaGroupId" + plantId) ? JSON.parse(ss.getItem("or_areaGroupId" + plantId)) : [],
        startDate: ls.get("or_startDate") || setCurrentDate(new Date()),
        endDate: ls.get("or_endDate") || setCurrentDate(new Date()),
    });

    useEffect(() => {
        getUserId();
        LoadAreaData();
        LoadBreakdownReasonGroup();

        dispatch(getStatusList());

        LoadHandler();
        if (isMobile) {
            setRowLength(1);
        }
    }, []);

    const [rows, setRows] = useState([]);
    const [statusData, setStatusData] = useState([]);
    const [hasMore, setHasMore] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);

    const [breakdownReasonGroupData, setBreakdownReasonGroupData] = useState([]);

    const { unPlannedMaintenance, statusList, areas, reasonGroup } = useSelector(({ breakDownTask }) => breakDownTask);
    const { creators, cancelOrder } = useSelector(({ operatorRequest }) => operatorRequest);
    const { snackMessage } = useSelector(({ layout }) => layout);
    const { userInformation } = useSelector(({ user }) => user);

    const checkCancelRolePermissions = async () => {
        try {
            const adminRoleCodes = ["SYSTEM_ADMIN", "PROD_ADMIN", "BUSINESS_ADMIN"];
            let adminRoleFound = false;
            for (const code of adminRoleCodes) {
                const response = await checkUserRole(code);
                if (response?.data?.resultObject === true) {
                    adminRoleFound = true;
                    break;
                }
            }
            if (adminRoleFound) {
                setCanCancelAnyTask(true);
                return;
            }
            await checkUserRole("PROD_OPERATOR");
            setCanCancelAnyTask(false);
        } catch (error) {
            setCanCancelAnyTask(false);
        }
    };

    const getUserId = () => {
        const oktaToken = JSON.parse(localStorage.getItem("okta-token-storage"));
        let userCode = oktaToken.idToken.claims.preferred_username.replace("@arcelik.com", "");
        setCurrentUserCode(userCode);
        setCurrentUserName(oktaToken.idToken.claims.name);
        dispatch(getUserInfo(userCode));
        checkCancelRolePermissions();
    };

    useEffect(() => {
        if (userInformation?.resultObject) {
            const { resultObject } = userInformation;
            setUserID(resultObject.mostUserId);
        }
    }, [userInformation]);

    useEffect(() => {
        if (unPlannedMaintenance?.firstCallRes) {
            if (state.status.length === 0) {
                setRows([]);
            }
            setRows(Object.values(unPlannedMaintenance.firstCallRes.resultObject.content));
            const hasNextPage = unPlannedMaintenance.firstCallRes.resultObject.hasNext;
            setHasMore(hasNextPage);
            if (hasNextPage) {
                setCurrentPage(2);
            }
        }
        if (unPlannedMaintenance?.fetchMoreDataRes) {
            const {
                fetchMoreDataRes: { resultObject },
            } = unPlannedMaintenance;

            setRows(rows.concat(Object.values(resultObject.content)));

            const hasNextPage = resultObject.hasNext;
            setHasMore(hasNextPage);
            if (hasNextPage) {
                setCurrentPage(currentPage + 1);
            }
        }
    }, [unPlannedMaintenance]);

    useEffect(() => {
        if (areas?.resultObject) {
            setAreaData(areas.resultObject);
        }
    }, [areas]);

    useEffect(() => {
        if (reasonGroup?.resultObject) {
            setBreakdownReasonGroupData(Object.values(reasonGroup.resultObject));
        }
    }, [reasonGroup]);

    useEffect(() => {
        if (statusList?.resultObject) {
            setPageLoaded(true);
            setStatusData(Object.values(statusList.resultObject));
            HandleStatusName(Object.values(statusList.resultObject), state.status);
            dispatch(resetStore());
        }
    }, [statusList]);

    useEffect(() => {
        if (creators?.response?.resultObject) {
            setHasMore(creators.response.resultObject.hasNext);
            setRows(Object.values(creators.response.resultObject));
        }
        if (creators?.resultObject) {
            setHasMore(creators.resultObject.hasNext);
            setRows(Object.values(creators.resultObject));
        }
    }, [creators]);

    useEffect(() => {
        if (cancelOrder?.resultObject) {
            dispatch(resetOrderResponse());
            LoadHandler();
        }
    }, [cancelOrder]);

    useEffect(() => {
        if (snackMessage?.response) {
            dispatch(setSnackMessage());
        }
    }, [snackMessage]);

    const LoadHandler = (filterCleared = false) => {
        setRows([]);
        const data = {
            startDate: state.startDate,
            endDate: state.endDate,
            statusArr: ls.get("status")?.toString() || [1, 2, 3, 4].toString(),
            creatorIds: ls.get("or_creatorId") ? [parseInt(ls.get("or_creatorId"))] : [],
            machineId: filterCleared ? 0 : machineStates.selectedSubEquipmentCode ?? machineStates.selectedMainEquipmentCode ?? 0,
            assigneedIds: [],
            breakdownGroupIds: ss.getItem("or_breakdownReasonGroup" + plantId) ? JSON.parse(ss.getItem("or_breakdownReasonGroup" + plantId)) : [],
            areaGroupIds: ss.getItem("or_areaGroupId" + plantId) ? JSON.parse(ss.getItem("or_areaGroupId" + plantId)) : [],
            taskID: state.taskID,
            poolIds: [],
            costCenterIds: [],
            breakdownEffectIds: [],
        };
        let payload = {
            data: data,
            currentPage: 1,
            pageSize: 11,
            firstCall: true,
        };
        setExcelFilterState(data);
        dispatch(getUnPlannedMaintenanceListMultiple(payload));
    };

    const isEwoButtonVisible = (createdDate) => {
        const currentTime = new Date(); // Şu anki zaman
        const createdTime = new Date(createdDate); // createdDate'in zamanını al
        const timeDifference = (currentTime - createdTime) / 1000 / 60; // Farkı dakika cinsinden hesapla
        return timeDifference > 10; // 10 dakika geçmişse true döner
    };

    //set status
    const HandleStatus = (event) => {
        setState({ ...state, status: event.target.value });
        HandleStatusName(statusData, event.target.value);
        ls.set("status", event.target.value);
    };

    //set status name
    const HandleStatusName = (rawArray, filterArray) => {
        const statusFiltered = rawArray.filter((el) => {
            return filterArray.some((f) => {
                return f === el.code;
            });
        });
        setSelectedStatusName(statusFiltered.map((item) => item.description));
    };

    const HandleAreaFilterChange = (areaName) => {
        let ids = [];
        areaName.map((item) => ids.push(item.id));
        if (areaName == []) {
            ss.removeItem("or_areaGroupId" + plantId);
        } else {
            ss.setItem("or_areaGroupId" + plantId, JSON.stringify(ids));
        }
        setState({ ...state, selectedAreaFilter: ids });
    };

    const HandleBreakdownReasonGroup = (breakdownReasonGroup) => {
        let ids = [];
        breakdownReasonGroup.map((item) => ids.push(item.id));
        if (breakdownReasonGroup == []) {
            ss.removeItem("or_breakdownReasonGroup" + plantId);
        } else {
            ss.setItem("or_breakdownReasonGroup" + plantId, JSON.stringify(ids));
        }
        setState({ ...state, breakdownReasonGroup: ids });
    };

    //set color
    const HandleColor = (row) => {
        return row.isStopped === true ? "red" : "#fbc02d";
    };

    const TimeFormat = (date) => {
        return moment(new Date(date)).format("LLL");
    };

    const CancelHandler = () => {
        dispatch(getCancelOrder(canceledID));
        ToggleModal();
    };

    const ConfirmHandler = () => {
        dispatch(getConfirmOrder(confirmedID));
        ToggleModal();
        LoadHandler();
    };

    //modal
    const [isModalOpen, setModalOpen] = useState(false);
    const [canceledID, setCanceledID] = useState();
    const CancelButtonHandler = (id) => {
        setCanceledID(id);
        ToggleModal();
    };

    //modal
    const [confirmedID, setConfirmedID] = useState();
    const ConfirmButtonHandler = (id) => {
        setConfirmedID(id);
        ToggleModal();
    };

    const ToggleModal = () => {
        setModalOpen((prevState) => !prevState);
    };

    const FetchMoreData = () => {
        const data = {
            statusArr: state.status.toString(),
            creatorIds: ls.get("or_creatorId") ? [parseInt(ls.get("or_creatorId"))] : [],
            machineId: machineStates.selectedSubEquipmentCode ?? machineStates.selectedMainEquipmentCode ?? 0,
            assigneedIds: [],
            breakdownGroupIds: ss.getItem("or_breakdownReasonGroup" + plantId) ? JSON.parse(ss.getItem("or_breakdownReasonGroup" + plantId)) : [],
            areaGroupIds: ss.getItem("or_areaGroupId" + plantId) ? JSON.parse(ss.getItem("or_areaGroupId" + plantId)) : [],
            taskID: state.taskID,
            startDate: state.startDate,
            endDate: state.endDate,
            poolIds: [],
            costCenterIds: [],
            breakdownEffectIds: [],
        };
        let payload = {
            data: data,
            currentPage: currentPage,
            pageSize: 7,
            fetchMoreData: true,
        };

        dispatch(getUnPlannedMaintenanceListMultiple(payload));
    };

    const HandleAssignToMe = (event) => {
        state.checkedMe = event.target.checked;
        setState({ ...state, checkedMe: event.target.checked });
        ls.set("checkedMe", event.target.checked);

        if (event.target.checked) {
            ls.set("or_creatorId", userID);
        } else {
            ls.remove("or_creatorId");
        }

        LoadHandler();
    };

    //load area data for popup
    let [areaData, setAreaData] = useState([]);
    const LoadAreaData = () => {
        dispatch(getAreaList());
    };

    const LoadBreakdownReasonGroup = () => {
        dispatch(getReasonGroup());
    };

    // Machine popup
    const initialMachineStates = (isCleared = false) => {
        return {
            ssAbr: "or",
            selectedAreaCode: isCleared ? null : ss.getItem("or_selectedAreaCode") ?? null,
            selectedAreaName: isCleared ? null : ss.getItem("or_selectedAreaName") ?? null,
            selectedMainEquipmentCode: isCleared ? null : ss.getItem("or_selectedMainEquipmentCode") ?? null,
            selectedMainEquipmentName: isCleared ? null : ss.getItem("or_selectedMainEquipmentName") ?? null,
            selectedSubEquipmentCode: isCleared ? null : ss.getItem("or_selectedSubEquipmentCode") ?? null,
            selectedSubEquipmentName: isCleared ? null : ss.getItem("or_selectedSubEquipmentName") ?? null,
        };
    };
    const [machineStates, setMachineStates] = useState(initialMachineStates);
    const HandleClearMachineStates = () => {
        ss.removeItem("or_selectedAreaCode");
        ss.removeItem("or_selectedAreaName");
        ss.removeItem("or_selectedMainEquipmentCode");
        ss.removeItem("or_selectedMainEquipmentName");
        ss.removeItem("or_selectedSubEquipmentCode");
        ss.removeItem("or_selectedSubEquipmentName");
        setMachineStates(initialMachineStates(true));
    };

    const infiniteScrollMessage = () => {
        if (rows.length == 0) {
            return (
                <p style={{ textAlign: "center" }}>
                    <b>{t("ThereIsNoRecord")}</b>
                </p>
            );
        } else {
            return (
                <p style={{ textAlign: "center" }}>
                    <b>{t("YouHaveSeenItAll")}</b>
                </p>
            );
        }
    };

    const loader = () => {
        if (rows.length > 7) {
            return <LinearProgress />;
        } else {
            return null;
        }
    };
    const handleRowLength = (event) => {
        if (event.target.value != "") {
            setRowLength(event.target.value);
            if (event.target.value > 5) {
                FetchMoreData();
            }
        }
    };

    const HandleApplyFilter = () => {
        LoadHandler();
    };

    const HandleClearFilter = () => {
        HandleClearMachineStates();

        setState({ ...state, status: [], taskID: 0, startDate: setCurrentDate(new Date()), endDate: setCurrentDate(new Date()) });
        HandleStatusName(statusData, []);
        ls.set("status", []);
        state.taskID = 0;
        state.startDate = setCurrentDate(new Date());
        state.endDate = setCurrentDate(new Date());
        ss.setItem("or_breakdownReasonGroup" + plantId, JSON.stringify([]));
        ss.setItem("or_areaGroupId" + plantId, JSON.stringify([]));

        LoadHandler(true);
    };

    const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);

    const toggleDrawer = (open) => (event) => {
        if (event && event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
            return;
        }
        setIsFilterDrawerOpen(open);
    };

    //set taskID state with taskNo area which comes from filter
    const FilterWithID = (e) => {
        setState({ ...state, taskID: e.target.value });
    };

    //set start date
    const HandleStartDate = (date) => {
        setState({ ...state, startDate: setCurrentDate(date) });
        ls.set("or_startDate", date);
    };

    //set end date
    const HandleEndDate = (date) => {
        setState({ ...state, endDate: setCurrentDate(date) });
        ls.set("or_endDate", date);
    };

    const CreateEwoForm = (row) => {
        console.log("rows", row);
        history.push("create-ewo-form?from=operator&id=" + row.id, { data: row });
    };

    const filter = () => {
        return (
            <DetailFilter
                HandleStatus={HandleStatus}
                statusData={statusData}
                status={state.status}
                selectedStatusName={selectedStatusName}
                HandleAreaFilterChange={HandleAreaFilterChange}
                areaData={areaData}
                selectedAreaFilter={state.selectedAreaFilter}
                isMultipleAreaGroup={true}
                HandleBreakdownReasonGroup={HandleBreakdownReasonGroup}
                breakdownReasonGroupData={breakdownReasonGroupData}
                breakdownReasonGroup={state.breakdownReasonGroup}
                setMachineStates={setMachineStates}
                machineStates={machineStates}
                isAreaNotFiltered={true}
                FilterWithID={FilterWithID}
                taskId={state.taskID}
                HandleStartDate={HandleStartDate}
                startDate={state.startDate}
                HandleEndDate={HandleEndDate}
                endDate={state.endDate}
            />
        );
    };

    return (
        <div>
            {pageLoaded === true ? (
                <Grid id="or_grid" style={{ marginTop: 20, marginLeft: 20, marginRight: 20 }}>
                    <FilterDrawer
                        open={isFilterDrawerOpen}
                        onOpen={toggleDrawer(true)}
                        onClose={toggleDrawer(false)}
                        HandleClearFilter={HandleClearFilter}
                        HandleApplyFilter={() => {
                            setIsFilterDrawerOpen(false);
                            HandleApplyFilter();
                        }}
                        detailFilter={filter()}
                        downloadExcel={() =>
                            dispatch(
                                downloadExcelFile({
                                    ...excelFilterState,
                                    startDate: excelFilterState.startDate ?? "2016-04-07",
                                    endDate: excelFilterState.endDate ?? "2025-05-26",
                                })
                            )
                        }
                    />
                    <FilterButton onClick={() => toggleDrawer(true)} />
                    <Grid id="or_grid_1" container alignItems="center" justifyContent="center">
                        <Grid id="or_grid_3" item xs={12} sm={12} md={4}>
                            <FormControlLabel
                                id="or_formControlLabel_1"
                                control={
                                    <Switch
                                        id="or_switch_1"
                                        checked={ls.get("checkedMe")}
                                        onChange={HandleAssignToMe}
                                        color="primary"
                                        name="checkedMe"
                                        inputProps={{ "aria-label": "primary checkbox" }}
                                    />
                                }
                                label={t("MyOrders")}
                                labelPlacement="end"
                            />
                        </Grid>
                        {!isMobile ? (
                            <Grid item xs={12} sm={12} md={4}>
                                <FormControl id="or_formControl_10" variant="outlined" style={{ width: "75%" }}>
                                    <TextField
                                        id="or_formControl_10"
                                        label={t("CardsPerRow")}
                                        inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                                        onChange={handleRowLength}
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 12);
                                            if (e.target.value == "NaN") {
                                                e.target.value = "";
                                            }
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                        ) : null}
                    </Grid>
                    <Grid id="or_Grid_16">
                        <InfiniteScroll
                            id="or_InfiniteScroll"
                            dataLength={rows.length} //This is important field to render the next data
                            next={FetchMoreData}
                            hasMore={hasMore}
                            loader={loader()}
                            endMessage={infiniteScrollMessage()}
                        >
                            <StyledGridUl rows rowLength={rowLength} id="or_StyledGridUl">
                                {rows.map((row, index) => {
                                    return (
                                        <OperatorRequestCard
                                            row={row}
                                            HandleColor={HandleColor}
                                            TimeFormat={TimeFormat}
                                            CreateEwoForm={CreateEwoForm}
                                            CancelButtonHandler={CancelButtonHandler}
                                            ConfirmButtonHandler={ConfirmButtonHandler}
                                            canCancelAnyTask={canCancelAnyTask}
                                            currentUserId={userID}
                                            currentUserCode={currentUserCode}
                                            currentUserName={currentUserName}
                                        />
                                    );
                                })}
                            </StyledGridUl>
                        </InfiniteScroll>
                    </Grid>
                </Grid>
            ) : null}
            <ScrollTop
                text="▲"
                distance={100}
                breakpoint={2000}
                style={{ backgroundColor: "#BCC5C6", borderRadius: "20px", border: "2px", color: "black" }}
                speed={200}
                target={0}
                number={10}
                icon={<ArrowDropUp />}
            />
            <Modal
                title={state.status == 5 ? t("Confirm") : t("Cancel")}
                content={t("WillYouDoTransaction")}
                approved={state.status == 5 ? ConfirmHandler : CancelHandler}
                isModalOpen={isModalOpen}
                toggle={ToggleModal}
            />
            <LoadingBackdrop />
        </div>
    );
}
